import {
  defineTokens,
  defineSemanticTokens,
  defineTextStyles,
} from '@chakra-ui/react';

import { colors } from './colors';
import { semanticConfig } from './colorSemantics';
import { typography } from './typography';

export const tokens = defineTokens({
  colors: colors,

  fonts: Object.fromEntries(
    Object.entries(typography.fonts).map(([k, v]) => [k, { value: v }]),
  ),

  fontSizes: Object.fromEntries(
    Object.entries(typography.fontSizes).map(([k, v]) => [k, { value: v }]),
  ),

  fontWeights: Object.fromEntries(
    Object.entries(typography.fontWeights).map(([k, v]) => [k, { value: v }]),
  ),

  lineHeights: Object.fromEntries(
    Object.entries(typography.lineHeights).map(([k, v]) => [k, { value: v }]),
  ),
});

export const semanticTokens = defineSemanticTokens({
  colors: semanticConfig,
});
